import { useRef } from "react";
import { debounce } from "lodash";

export function useDebounced<T extends (...args: any[]) => any>(cb: T, timeout = 400) {
  const debounced = useRef(debounce(cb, timeout));
  return { debounced: debounced.current };
}
